import React from "react"
import MammaneroCaffeDomain from "../domains/MammaneroCaffe/MammaneroCaffeDomain/MammaneroCaffeDomain"
const MamaneroCaffe = () => {
  return <MammaneroCaffeDomain />
}
export default MamaneroCaffe
